import {
  type QueryFunctionContext,
  type QueryObserverOptions,
  useQuery
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { integrationClientsQueryKeys } from 'queries/integration-clients/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { AxiosError } from 'axios'
import type { PrivateNetworkIntegrationClient } from 'types/api/integration-clients/integration-clients'

export type IntegrationClientsResponse = {
  active: PrivateNetworkIntegrationClient[]
  idle: PrivateNetworkIntegrationClient[]
  inactive: PrivateNetworkIntegrationClient[]
}

function fetchIntegrationClients({
  queryKey: [endpoint, params]
}: QueryFunctionContext<ReturnType<typeof integrationClientsQueryKeys.get>>) {
  const endpointWithParams = getEndpointWithParams(endpoint, params)

  return fetchQueryData<IntegrationClientsResponse>(endpointWithParams)
}

export const useGetIntegrationClients = (
  options?: Omit<
    QueryObserverOptions<IntegrationClientsResponse, AxiosError>,
    'queryFn' | 'queryKey'
  >
) => {
  const { currentTeamId: teamId } = useAuth()

  return useQuery<IntegrationClientsResponse, AxiosError>({
    ...options,
    queryKey: integrationClientsQueryKeys.get({ teamId }),
    queryFn: fetchIntegrationClients
  })
}
